import {
  startToolOperation,
  trackToolRejection,
  type ToolAnalyticsContext,
} from '@saas-pages/shared/public/runtime'

const CONTEXT: ToolAnalyticsContext = {
  app: 'txtify',
  domain: 'txtify.ru',
  route: '/transliteraciya',
  utility: 'transliteration',
  processingMode: 'local',
}

export function reportTransliterationSuccess(durationMs: number): void {
  startToolOperation(CONTEXT).success(durationMs)
}

export function reportTransliterationRejection(): void {
  trackToolRejection(CONTEXT, 'size_limit')
}
